export default __webpack_public_path__ + "static/blog_10-0703029f2cdccb05aac7c42fc9db1802.png";